import ProjectPropertyCreateModal from "./ProjectPropertyCreateModal"

export default ProjectPropertyCreateModal
